import { CContainer, CRow, CCol, CButton } from '@coreui/react';
import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomBreadcrumbs,  } from '../../components';
import SponsorsTable from '../../components/Table/SponsorsTable';
import { AppContext } from '../../context/AppContext';
import styles from './Sponsors.module.css';

const Sponsors = () => {

  const navigate = useNavigate();

  const { state, getSponsors, sponsorsPageUrl } = React.useContext(AppContext);
  const columns = [
    {
      key: '',
      label: '#',
      _props: { scope: 'col' }
    },
    {
      key: 'image',
      label: 'Imagen',
      _props: { scope: 'col' }
    },
    {
      key: 'name',
      label: 'Nombre',
      _props: { scope: 'col' }
    },
    {
      key: 'actions',
      label: 'Acciones',
      _props: { scope: 'col' }
    }
  ];

  //Effects
  useEffect(() => {
    getSponsors();
  }, [sponsorsPageUrl]);

  return (
    <div>
      <CustomBreadcrumbs parentTitle={'Refugios'} activeTitle="Auspiciantes" />
      <CContainer>
        <CRow>
          <CCol xs={12}>
            <div className={styles.orderContainer}>
              <div className={styles.orderHeader}>
                <h2 className='title'>Auspiciantes</h2>
                <CButton 
                    size="lg" 
                    color="primary" 
                    onClick={() => navigate("/dashboard/sponsors/add")} 
                    className={styles.button}
                >
                    Agregar auspiciante
                </CButton>
              </div>
            </div>
          </CCol>
          <SponsorsTable
            columns={columns} 
            data={state?.sponsors} 
            pagination={state?.sponsorsPagination} 
          />
        </CRow>
      </CContainer>
    </div>
  );
};

export default Sponsors;
